var map = {
	"./agent-office-supplies.svg": "3QJF",
	"./alipay_fang.svg": "QjXG",
	"./all.svg": "nFMN",
	"./anmoyi.svg": "IbOl",
	"./anmoyi_active.svg": "cuim",
	"./arrow-down.svg": "gHQO",
	"./balance_fang.svg": "gaYW",
	"./balance_pay.svg": "1Ufk",
	"./cz.svg": "hMhR",
	"./data_analysis.svg": "QXj+",
	"./data_analysis_active.svg": "Poio",
	"./device_edit.svg": "ZsjP",
	"./device_offline.svg": "bWcQ",
	"./device_open.svg": "MOyx",
	"./earnings.svg": "7cDO",
	"./filter.svg": "0VRl",
	"./help.svg": "+LEE",
	"./logo.svg": "GKIU",
	"./long-arrow-down.svg": "TzvD",
	"./long-arrow-up.svg": "0MhQ",
	"./more.svg": "jLwj",
	"./more_active.svg": "cnjI",
	"./order.svg": "yFxS",
	"./qrcode.svg": "kaac",
	"./recharge_order.svg": "RVJJ",
	"./settings.svg": "4yB9",
	"./signal.svg": "niRo",
	"./site_icon.svg": "1TfZ",
	"./site_icon_active.svg": "kQwG",
	"./sort-down.svg": "ps7D",
	"./sort-down_active.svg": "Jylr",
	"./sort-up.svg": "6kjM",
	"./sort-up_active.svg": "jKlc",
	"./trends.svg": "ltq7",
	"./trends_active.svg": "4QWt",
	"./weixin_fang.svg": "YguB",
	"./xfjl.svg": "lHEa",
	"./xfjl_yellow.svg": "hcpB",
	"./year_card_icon.svg": "Jpfw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Dtgc";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/device/svg ^\.\/.*$
// module id = Dtgc
// module chunks = 1